import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { fieldBoxContent } from './content.vanilla.mjs';

const FieldBoxContent = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(fieldBoxContent, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "field-box",
      "data-part": "content",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});
FieldBoxContent.displayName = "FieldBox.Content";

export { FieldBoxContent };
//# sourceMappingURL=Content.mjs.map
